// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__nm0Tf","links":"styles_links__u1vws","copyright":"styles_copyright__8MAav"};